import { render, staticRenderFns } from "./AddImpairment.vue?vue&type=template&id=399a1396&scoped=true"
import script from "./AddImpairment.vue?vue&type=script&lang=js"
export * from "./AddImpairment.vue?vue&type=script&lang=js"
import style0 from "./AddImpairment.vue?vue&type=style&index=0&id=399a1396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a1396",
  null
  
)

export default component.exports